import { useState } from "react";
import type { InputProps } from "./InputProps";
import Input from "./Input";

type PasswordInputProps = Omit<InputProps, "type">;

export default function PasswordInput(props: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <Input
      {...props}
      type={showPassword ? "text" : "password"}
      iconName={showPassword ? "eye" : "eye-slash"}
      onIconClick={() => setShowPassword(!showPassword)}
    />
  );
}
